<template>
  <div>
    <BaseDialog 
      v-model="isVisible"
      center
      class="location-setting-drawer"
      :show-close="false"
      :close-on-click-modal="!loading"
    >
      <div class="text-xs-center py--2">
        <img class="py--4" :src="require('@/assets/icons/svg/location-setting.svg')" />
        <h1 class="text-title ma--0 color-charcoal--text">{{ $t('drawer.locationSetting.title') }}</h1>
        <p 
          class="text-heading3 ma--0 py--3 color-info--text" 
          style="word-break: break-word;"
        >
          {{ $t('drawer.locationSetting.description') }}
        </p>
        <BaseButton 
          @click="useCurrentLocation"
          :loading="loading"
          class="full-width color-primary color-white--text my--3"
        >
          {{ $t('drawer.locationSetting.useCurrentLocation') }}
        </BaseButton>
        <BaseButton 
          @click="useCustomLocation"
          class="full-width color-primary--text color-primary--border color-white"
        >
          {{ $t('drawer.locationSetting.useCustomLocation') }}
        </BaseButton>
      </div>
      </BaseDialog>
      <BaseDialog 
        center
        class="warning-drawer"
        v-model="isWarningDrawerOpen"
        :withHeader="false" 
        :show-close="false" 
        :destroy-on-close="true"
        direction="btt"
      >
        <div class="text-xs-center" style="word-break: break-word;">
          <span class="text-heading3 color-black--text">
            {{ warningDescription }}
          </span>
        </div>
      </BaseDialog>
  </div>
</template>

<script>
import LocationUtil from "@/utils/location"

import BaseButton from '@/baseComponents/button/BaseButton.vue'
import BaseDialog from '@/baseComponents/dialog/BaseDialog.vue'

export default {
  name: 'LocationSettingDrawer',
  components: {
    BaseButton,
    BaseDialog
  },
  props: {
    value: {
      default: false
    }
  },
  data: function() {
    return { 
      loading: false,
      isWarningDrawerOpen: false,
      warningDescription: ''
    }
  },
  computed: {
    isVisible: {
      get: function() {
        return this.value
      },
      set: function(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    close: function() {
      this.isVisible = false
    },
    useCurrentLocation: async function() {
      try {
        this.loading = true
        const currentLocation = await LocationUtil.getCurrentLocation()
        this.$emit('use:current', {
          lat: currentLocation.geometry.location.lat(), 
          lng: currentLocation.geometry.location.lng(),
          address: currentLocation.formatted_address,
          address_longname: currentLocation.address_components[0].long_name
        })
        this.close()
      } catch (error) {
        if (error instanceof GeolocationPositionError) {
          this.isWarningDrawerOpen = true
          this.warningDescription = error.code === 1 ? this.$t('drawer.locationSetting.allowLocationWarning') : error.message
        }
        throw error
      }
      finally {
        this.loading = false
      }
    },
    useCustomLocation: async function() {
      this.$emit('use:custom')
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.warning-drawer {
  /deep/ {
    .el-dialog {
      width: 280px;
    }

    .el-dialog__header {
      padding: 0;
    }
  }
}
.location-setting-drawer {
  /deep/ {
    .el-dialog {
      width: 300px;
    }

    .el-dialog__title {
      font-weight: 400;
      font-size: 18px;
    }

    .el-dialog__body {
      padding: 0px 18px 18px 18px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/locationsetting/LocationSettingDrawer.vue